var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "panels flex" },
    _vm._l(_vm.list, function (item, index) {
      return _c("div", { key: index, staticClass: "row" }, [
        _c("div", { staticClass: "imggs flex" }, [
          _c(
            "div",
            { staticClass: "demo-image__preview" },
            [
              _c("el-image", {
                staticClass: "imgs",
                attrs: {
                  src: _vm.$config.imgIp + item.pic,
                  "preview-src-list": _vm.imgList,
                },
              }),
            ],
            1
          ),
        ]),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }